let targetNode = document.querySelector('html');
      let floCheckoutBtn = `<button type="button" id="checkout2"  onclick="handleFloCheckoutBtn()" class="button full" name="checkout2">Checkout</button>`;
      let parsedFloBtn = new DOMParser().parseFromString(floCheckoutBtn, 'text/html').querySelectorAll('#checkout2')[0];
      parsedFloBtn.addEventListener('click', () => window.SLIDECART_CLOSE?.());
      let isFloBtnAdded = false;
      const stickyCartCb = function (mutationList) {
        mutationList.forEach((mutation) => {
          let stickyCart = document.querySelector('#slidecarthq');
          let sideCartButtonParent = document.querySelector('#slidecart-checkout-form');
          let sideCartButton = document.querySelector('#slidecart-checkout-form');
          mutation.addedNodes.forEach((added_node) => {
            if (stickyCart) {
              if (sideCartButtonParent && !isFloBtnAdded) {
                isFloBtnAdded = true;
                sideCartButton.style.display = 'none';
                sideCartButton.before(parsedFloBtn);
              }
            }
          });
        });
      };
      const stickyCartObserver = new MutationObserver(stickyCartCb);
      const config = { attributes: true, childList: true, subtree: true };
      stickyCartObserver.observe(targetNode, config);



        document.addEventListener('DOMContentLoaded', () => {
        const privacyEle = document.querySelector('#privacy-policy-link');
        const termsEle = document.querySelector('#terms-and-condition-link');
        if ((privacyEle && privacyEle.style.display !== 'none') || (termsEle && termsEle.style.display !== 'none')) {
          const targetElement = privacyEle && privacyEle.style.display !== 'none' ? privacyEle : termsEle;
          targetElement.closest('section').style.marginBottom = '90px';
        }
      });